import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import manoleLogo from '../images/logo-manole.svg'
import Button from '@material-ui/core/Button'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { authActions, messageActions } from '../actions'
import { CpfField } from '../components/Fields'
import { Link } from 'react-router-dom'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import InputAdornment from '@material-ui/core/InputAdornment'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '340px'
  }),
  capsLockWarning: {
    position: 'absolute',
    bottom: '-25px',
    margin: 0,
    color: '#212121',
    fontSize: '13px'
  },
  resetPassLink: {
    margin: '16px 0'
  },
  wrapperLoader: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControlPassword: {
    marginBottom: '25px'
  },
  formControl: {
    margin: '14px 0'
  },
  logo: {
    margin: '0 auto',
    display: 'block'
  },
  versionLabel: {
    alignItems: 'center',
    '& > p': {
      color: 'rgba(0, 0, 0, 0.5)',
      fontSize: '13px',
      textAlign: 'center'
    }
  }
})

class Login extends Component {
  state = {
    cpf: '',
    pass: '',
    showError: false,
    showPassword: false,
    showCapsLockMessage: false
  }
  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }
  handleChangeCpf = cpf => {
    this.setState({
      cpf,
      showError: false
    })
  }
  handleChangePass = pass => {
    this.setState({
      pass,
      showError: false
    })
  }
  componentDidMount() {
    document.onkeyup = this.toggleCapsLockMessage
    document.onkeydown = this.toggleCapsLockMessage
  }
  componentWillUnmount() {
    document.onkeyup = undefined
    document.onkeydown = undefined
  }
  toggleCapsLockMessage = e => {
    this.setState({
      showCapsLockMessage: e.getModifierState && e.getModifierState('CapsLock')
    })
  }
  componentWillReceiveProps(props) {
    if (props.err) {
      this.setState(state => {
        return {
          showError: true
        }
      })
    }
  }
  handleLogin = e => {
    e.preventDefault()
    const { pass: password, cpf } = this.state
    if (/^[0-9]{3}\.[0-9]{3}.[0-9]{3}-[0-9]{2}$/.test(cpf) && password) {
      this.props
        .login({ cpf: cpf.replace(/\.|-/g, ''), password })
        .then(response => {
          const message = 'Usuário autenticado com sucesso.'
          this.props.changeMessage({ message })
        })
        .catch(error => {
          const { response = {} } = error
          const { status } = response
          const message = status === 401 ? 'CPF e/ou senha inválidos.' : 'Serviço indisponível.'
          this.props.changeMessage({
            message,
            anchorOrigin: { horizontal: 'center', vertical: 'top' }
          })
        })
    }
    return false
  }
  render() {
    const { handleChangePass, handleLogin } = this
    const { classes, token, loading, err } = this.props
    const { cpf, pass, showError, showCapsLockMessage } = this.state
    if (token) {
      return <Redirect to="/" />
    }
    if (loading) {
      return (
        <div className={classes.wrapperLoader}>
          <CircularProgress className={classes.progress} />
        </div>
      )
    }
    return (
      <div className={classes.root}>
        <Paper className={classes.box} elevation={4}>
          <img src={manoleLogo} alt={'Logotipo Manole'} className={classes.logo} width={100} />
          <div className={classes.versionLabel}>
            <p>versão {process.env.REACT_APP_PACKAGE_VERSION}</p>
          </div>
          <form noValidate id="form-login" onSubmit={handleLogin} className={classes.formGroup}>
            <FormControl fullWidth className={classes.formControl}>
              <InputLabel error={!!(err && showError)} htmlFor="field-cpf">
                CPF
              </InputLabel>
              <Input
                value={cpf || ''}
                autoFocus
                error={!!(err && showError)}
                fullWidth
                onChange={e => {
                  this.handleChangeCpf(e.target.value)
                }}
                id="field-cpf"
                inputComponent={CpfField}
              />
            </FormControl>

            <FormControl fullWidth className={classes.formControlPassword}>
              <InputLabel error={!!(err && showError)} htmlFor="field-password-login">
                Senha
              </InputLabel>
              <Input
                value={pass}
                fullWidth
                error={!!(err && showError)}
                type={this.state.showPassword ? 'text' : 'password'}
                onChange={e => {
                  handleChangePass(e.target.value)
                }}
                id="field-password-login"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.handleClickShowPassword}
                      onMouseDown={this.handleMouseDownPassword}
                    >
                      {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              {showCapsLockMessage ? (
                <Typography className={classes.capsLockWarning}>
                  Atenção: <strong>CAPS Lock</strong> está ligado
                </Typography>
              ) : null}
            </FormControl>
          </form>
          <Button
            variant="raised"
            fullWidth
            type={'submit'}
            color="primary"
            form={'form-login'}
            disabled={!(/^[0-9]{3}\.[0-9]{3}.[0-9]{3}-[0-9]{2}$/.test(cpf) && pass)}
            className={classes.button}
          >
            Entrar
          </Button>
          <br />
          <Link to="/redefinir-senha">
            <Typography className={classes.resetPassLink} color={'primary'}>
              Esqueci minha senha
            </Typography>
          </Link>
        </Paper>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  token: state.auth.token,
  err: state.auth.err,
  loading: state.auth.loading
})

const mapDispatchToProps = dispatch => {
  return {
    login: ({ cpf, password }) => {
      return dispatch(authActions.login({ cpf, password }))
    },
    changeMessage: ({ message, anchorOrigin }) => {
      dispatch(messageActions.changeMessage({ message, anchorOrigin }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Login))



// WEBPACK FOOTER //
// ./src/containers/Login.js